"use client"

import { useState } from "react"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Button } from "@/components/ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

export function Configurations() {
  const defaultConfig = {
    host: "api.voice-agent.ai",
    agentName: "openai_agent",
    sampleRate: "16000",
    organizationName: "Acme Corporation",
    phoneNumber: "+1 (555) 123-4567",
    initialPrompt: "Hello! Thank you for calling Acme Corporation. How can I help you today?",
  }

  const [config, setConfig] = useState(() => {
    try {
      const saved = localStorage.getItem("voiceAgent.config")
      return saved ? JSON.parse(saved) : defaultConfig
    } catch (e) {
      return defaultConfig
    }
  })

  const availableVariables = [
    "{{caller_name}}",
    "{{caller_phone}}",
    "{{call_timestamp}}",
    "{{agent_name}}",
    "{{organization_name}}",
  ]

  return (
    <div className="space-y-8">
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label htmlFor="host">Host</Label>
            <Input id="host" value={config.host} onChange={(e) => setConfig({ ...config, host: e.target.value })} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="agent-name">Agent Name</Label>
            <Select value={config.agentName} onValueChange={(value) => setConfig({ ...config, agentName: value })}>
              <SelectTrigger id="agent-name">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                    <SelectItem value="openai_agent">OpenAI Agent</SelectItem>
                    <SelectItem value="gemini_agent">Gemini Agent</SelectItem>
                    <SelectItem value="gemini_agent_webrtc">Gemini Agent WebRTC</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="sample-rate">Sample Rate (Hz)</Label>
            <Input
              id="sample-rate"
              type="number"
              value={config.sampleRate}
              onChange={(e) => setConfig({ ...config, sampleRate: e.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="organization">Organization Name</Label>
            <Input
              id="organization"
              value={config.organizationName}
              onChange={(e) => setConfig({ ...config, organizationName: e.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="phone">Phone Number</Label>
            <Input
              id="phone"
              value={config.phoneNumber}
              onChange={(e) => setConfig({ ...config, phoneNumber: e.target.value })}
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="initial-prompt">Initial Prompt</Label>
          <Textarea
            id="initial-prompt"
            value={config.initialPrompt}
            onChange={(e) => setConfig({ ...config, initialPrompt: e.target.value })}
            className="min-h-[100px]"
          />
        </div>

        <div className="space-y-2">
          <Label>Available Variables</Label>
          <div className="rounded-lg border border-border bg-muted/30 p-4">
            <div className="flex flex-wrap gap-2">
              {availableVariables.map((variable) => (
                <code
                  key={variable}
                  className="rounded bg-secondary px-2 py-1 text-xs font-mono text-secondary-foreground"
                >
                  {variable}
                </code>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-2 pt-4 border-t border-border">
        <Button
          variant="outline"
          onClick={() => {
            setConfig(defaultConfig)
            try {
              localStorage.removeItem("voiceAgent.config")
            } catch (e) {
              /* ignore */
            }
          }}
        >
          Reset
        </Button>
        <Button
          onClick={() => {
            try {
              localStorage.setItem("voiceAgent.config", JSON.stringify(config))
            } catch (e) {
              console.error("Could not save configuration", e)
            }
          }}
        >
          Save Configuration
        </Button>
      </div>
    </div>
  )
}
